import React from 'react'
import { admissionsMockData } from './utils/mockdata'
import useAdmissionFilters from './hooks/useAdmissionFilters'
import useAdmissionModal from './hooks/useAdmissionModal'
import AdmissionsHeader from './Components/AdmissionsHeader'
import AdmissionsFilters from './Components/AdmissionsFilters'
import AdmissionsTable from './Components/AdmissionsTable'
import NewAdmissionModal from './Components/NewAdmissionModal'

const Admissions = () => {
  // Use our custom hooks
  const {
    searchText,
    setSearchText,
    dateRange,
    setDateRange,
    statusFilter,
    setStatusFilter,
    departmentFilter,
    setDepartmentFilter,
    departments,
    filteredData
  } = useAdmissionFilters(admissionsMockData)

  const { isModalVisible, form, showModal, handleCancel, handleAdd } = useAdmissionModal()

  return (
    <div style={{ padding: '24px' }}>
      {/* Header with title and add button */}
      <AdmissionsHeader showModal={showModal} />

      {/* Filters for searching and filtering admissions */}
      <AdmissionsFilters
        searchText={searchText}
        setSearchText={setSearchText}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        departmentFilter={departmentFilter}
        setDepartmentFilter={setDepartmentFilter}
        dateRange={dateRange}
        setDateRange={setDateRange}
        departments={departments}
      />

      {/* Admissions Table */}
      <AdmissionsTable admissionsData={filteredData} />

      {/* New Admission Modal */}
      <NewAdmissionModal
        isVisible={isModalVisible}
        onCancel={handleCancel}
        onAdd={handleAdd}
        form={form}
        departments={departments}
      />
    </div>
  )
}

export default Admissions
